import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TokenContext from './TokenContext';
import { Button, Typography, Box } from '@mui/material';
import rappiLogo from "../resources/rappi.png"; 
import googleLogo from "../resources/google-logo.png"; 

import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const Container = styled(Box)`
  display: flex;
  height: 100vh;
`;


const moveCycleAnimation = keyframes`
  0% {
    left: -200px;
    opacity: 0;  // Comienza invisible
  }
  10% {
    opacity: 1;  // Se hace completamente visible durante el 10% de la animación
  }
  80% {
    opacity: 1;  // Permanece completamente visible hasta el 80% de la animación
  }
  100% {
    left: calc(50vw - 157px);
    opacity: 0;  // Se vuelve invisible nuevamente al final
  }
`;

const StyledGif = styled.img`
  position: absolute;
  bottom: 0;
  width: 200px;
  height: 200px;
  animation: ${moveCycleAnimation} 10s linear infinite; 
`;

const LeftSection = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  background: linear-gradient(to bottom, #a2dffc 0%, #ffffff 100%); // De un azul claro (cielo) en la parte superior a blanco en la parte inferior
  color: black; 
`;

const RightSection = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  background: linear-gradient(135deg, #2a2a2a 0%, #444444 100%);
`;

const WelcomeTitle = styled(Typography)`
  font-family: 'Poppins', sans-serif; 
  font-weight: 800; 
  font-size: 3rem;
  border-radius: 10px;
  padding: 10px;
  text-align: center;
  color: black;
`;



const TopRightImage = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 230px;
  height: auto;
  z-index: 1000;
`;

const LoginButton = styled(Button)`
  width: 60%;
  background-color: #e0e0e0;
  color: black;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 1.1rem;
  padding: 10px 20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    background-color: #b0b0b0;
    transform: translateY(-2px);
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15);
  }
`;


const Login = () => {
  const { setToken } = useContext(TokenContext);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
      setToken(token);
      navigate('/banners');
    }
  }, [setToken, navigate]);

  const handleLogin = () => {
    const gatewayUrl = 'https://services.grability.rappi.com/api/ms/core-home-auth/oauth/login/google'; 

    window.location.href = gatewayUrl;
  };

  return (
    <Container>
      <TopRightImage
         src={rappiLogo}
        alt="rappi"
      />
      <LeftSection>
        <WelcomeTitle variant="h1" component="h1">
          Welcome
        </WelcomeTitle>
        <StyledGif src="https://img.rappi.com/web/loader-rt.gif" alt="Loading gif" />
      </LeftSection>
      <RightSection>
        <LoginButton
          variant="contained"
          onClick={handleLogin}
          startIcon={<img src={googleLogo} alt="Google logo" width="20" />}
        >
          Sign in to Home CMS
        </LoginButton>
      </RightSection>
    </Container>
  );
};

export default Login;
